import { border as borderColor } from './palette'
import { fontWeight, fontFamily } from './typography'

export const borderWidth = {
  none: '0px',
  main: '1px',
  thick: '2px',
  thicker: '3px',
  thickest: '5px',
}

const createBorders = bc => {
  let borders = {}
  for (let key in bc) borders[key] = `${borderWidth.main} solid ${bc[key]}`
  return borders
}

export const border = createBorders(borderColor)

export const borderRadius = {
  none: 0,
  less: 1,
  main: 3,
  more: 6,
  extra: 10,
  doubleExtra: 20,
  triple: 30,
  roundInput: 23,
  full: 100,
}

export const opacity = {
  hide: 0,
  disabled: 0.25,
  half: 0.5,
  main: 0.6,
  none: 1,

  0: 0,
  1: .1,
  2: .2,
  3: .3,
  4: .4,
  5: .5,
  6: .6,
  7: .7,
  8: .8,
  9: .9,
  10: 1,
}

export const aspectRatio = {
  '3_4': '75%',
  '16_9': '1.78%',
}

export const height = {
  header: 45,
  footer: 50,
  inputTall: 55,
  input: 46,
  inputShort: 36,
}

const globals = {
  border,
  borderWidth,
  borderRadius,
  opacity,
  height,
  aspectRatio,
  spaceBase: 10,
  fontWeight,
  fontFamily,
}

export default globals
